.root {
  height: 420px;
  min-height: 320px;
  width: 100%;
  margin: 12px 0 20px;
  overflow: hidden;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--surface-default);
}

.chart {
  height: 100%;
}

.skeletonLoader {
  height: 420px;
  min-height: 320px;
  width: 100%;
}